import {
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_RECEIVE,
  FETCH_PRODUCTS_ERROR,
} from './../actions/products';

const initialState = {
  isFetching: false,
  error: false,
  products: [],
};

const productsReducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCTS_REQUEST:
      return {
        ...state,
        isFetching: true,
        products: [],
      };
    case FETCH_PRODUCTS_RECEIVE:
      return {
        ...state,
        isFetching: false,
        products: action.products,
      };
    case FETCH_PRODUCTS_ERROR:
      return {
        ...state,
        isFetching: false,
        products: [],
      };
    default:
      return state;
  }
};

export default productsReducers;
